import { createSlice } from "@reduxjs/toolkit";

export const rewardsSlice = createSlice({
  name: "rewards",
  initialState: {
    liveRewards: { list: [], meta: {} },
    deletedRewards: { list: [], meta: {} },
    rewardDetails: {},
    rechargeAmounts: [],
    discountAmounts: [],
    voucherAmounts: [],
    rewardingReport: null,
  },
  reducers: {
    getRewardsListRequest: () => {},
    getRewardsListResponse: (state, action) => {
      state.liveRewards.list = action.payload?.rewards;
      state.liveRewards.meta = action.payload?.meta;
    },
    getDeletedRewardsListRequest: () => {},
    getDeletedRewardsListResponse: (state, action) => {
      state.deletedRewards.list = action.payload?.rewards;
      state.deletedRewards.meta = action.payload?.meta;
    },
    getRewardsDetailsRequest: () => {},
    getRewardsDetailsResponse: (state, action) => {
      state.rewardDetails = action.payload;
    },
    addRewardsRequest: () => {},
    editRewardsRequest: () => {},
    deleteRewardsRequest: () => {},
    getRechargeAmountsRequest: () => {},
    getRechargeAmountsResponse: (state, action) => {
      state.rechargeAmounts = action.payload;
    },
    getDiscountAmountsRequest: () => {},
    getDiscountAmountsResponse: (state, action) => {
      state.discountAmounts = action.payload;
    },
    getVoucherAmountsRequest: () => {},
    getVoucherAmountsResponse: (state, action) => {
      state.voucherAmounts = action.payload;
    },
    getRewardingReportRequest: () => {},
    getRewardingReportResponse: (state, action) => {
      state.rewardingReport = action.payload;
    },
  },
});

export const {
  getRewardsListRequest,
  getRewardsListResponse,
  getRewardsDetailsRequest,
  getRewardsDetailsResponse,
  addRewardsRequest,
  editRewardsRequest,
  deleteRewardsRequest,
  getRechargeAmountsRequest,
  getRechargeAmountsResponse,
  getDiscountAmountsRequest,
  getDiscountAmountsResponse,
  getVoucherAmountsRequest,
  getVoucherAmountsResponse,
  getRewardingReportRequest,
  getRewardingReportResponse,
  getDeletedRewardsListRequest,
  getDeletedRewardsListResponse,
} = rewardsSlice.actions;
export default rewardsSlice.reducer;
